module.exports = __webpack_public_path__ + "static/banner-5408a673b631e37e81577772455d5b48.png";